import React, { Component } from 'react';
import moment from 'moment';

import ParkinglocationGroupsForm from './ParkinglocationGroupsForm'
import ParkinglocationGroupsModel from './ParkinglocationGroupsModel'
import { defaultSorter, dateSorter } from './Helpers';
import UserModel from './UserModel'

import { Table, Popconfirm, Divider, Typography, Tooltip, message } from 'antd';

class ParkinglocationGroupsTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    defaultFormData: null,
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  render() {
    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Kód',
      dataIndex: 'code',
      key: 'code',
      width: 150,
      defaultSortOrder: 'ascend',
      sorter: (a, b) => defaultSorter(a.code, b.code),
      render: (text, rec) => {
        return <Tooltip placement="right" title={rec.id}>{text}</Tooltip>
      },
    }, {
      title: 'Název',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => defaultSorter(a.name, b.name),
    }, {
      title: 'Kapacita',
      dataIndex: 'totalCapacity',
      key: 'totalCapacity',
      width: 100,
    }, {
      title: 'Obsazeno',
      dataIndex: 'totalOcc',
      key: 'totalOcc',
      width: 100,
    }, {
      title: 'Čas poslední změny',
      dataIndex: 'lastStateChange',
      key: 'lastStateChange',
      width: 200,
      render: (text, record) => {
        if (text !== undefined) {
          return moment(text).format('L LTS');
        }
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 200,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONSGROUPS_WRITE'])) {
          return (
            <div>
              <a onClick={(e) => {
                this.setState({
                  defaultFormData: record
                });
              }}>Nastavení</a>
              <Divider type="vertical" />
              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow
                  ? this.props.onRemoveRow(record.id)
                  : null;
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      }
    }]

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          onChange={this.handleChange}
          style={{ border: '0px' }} />
        <ParkinglocationGroupsForm
          type="modal"
          title="Editace skupiny lokalit"
          modalVisible={this.state.defaultFormData === null ? false : true}
          initialValues={this.state.defaultFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ defaultFormData: null });
          }}
          onSuccess={(form, values) => {
            ParkinglocationGroupsModel.update(this.state.defaultFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  defaultFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default ParkinglocationGroupsTable;


// WEBPACK FOOTER //
// ./src/components/ParkinglocationGroupsTable.js